import { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { MemberProfilesAPITypes } from 'types/memberprofiles'

import { projectClient } from 'constants/project'
import { ACCESS_CONFIG } from './config'
import { USER_TYPES } from './usertypes'
import { ClientNames, ClientUserTypeNames } from './clients'
import { ModuleNames, SubModuleNames, SubSubModuleNames } from './modules'
import { lookup } from 'dns'
const projectAllClients = ACCESS_CONFIG.application.clients
const projectAllModules = ACCESS_CONFIG.application.modules

type ModuleTypes = (typeof projectAllModules)[number]['name']
type SubModuleTypes = (typeof projectAllModules)[number]['subs'][number]['name']
type ClientSetupsTypes = (typeof projectAllClients)[number]['setup'][number]

export type AccessStatusTypes =
  (typeof projectAllModules)[number]['access']['status'][number]['status']

interface NavModulesTypes {
  module: string
  route: {
    title: string
    path: {
      path: string
      permissionIds: number[]
    }
    pathname?: string
    icon?: IconDefinition
    className?: string
    childClassName?: string
    iconClassName?: string
    children?: NavModulesTypes[]
  }
  Modal?: ({
    title,
    open,
    onClose,
    member,
  }: {
    title: string | undefined
    open: boolean
    onClose: () => void
    member?: MemberProfilesAPITypes
  }) => JSX.Element
  value?: string
  label?: string
}

interface CurrencyTypes {
  countryCode: string
  currency: string
}

export const accessControlNavigation = (
  projectClient: ClientNames,
  navModules: NavModulesTypes[]
): NavModulesTypes[] => {
  const projectModules = projectAllClients
    .filter((item) => item.name === projectClient?.toLowerCase())
    .map((item) => item.setup)[0]

  const filteredNavModules = navModules.filter((x) =>
    projectModules.some((y) => y.module === x.module.toLowerCase())
  )

  return filteredNavModules
}

export const accessControlSubNavigation = (
  projectClient: ClientNames,
  navModules: NavModulesTypes[],
  navModule: ModuleTypes
): NavModulesTypes[] => {
  const projectModules = projectAllClients
    .filter((item) => item.name === projectClient?.toLowerCase())
    .map((itemClient) => {
      const isAllSubs = itemClient.setup
        .filter((item) => item.module === navModule)
        .map((item) => item.subs)
        .map((item) => item[0])
        .filter((item) => item.name === '*').length
        ? true
        : false

      const excludedSubs = itemClient.setup
        .filter((item) => item.module === navModule)
        .map((item) => item.exclude)[0]
      // .map((item) => item[0])
      // .map((item) => item.name)

      if (isAllSubs) {
        // RETURN ALL SUB MODULES FOR THE MODULE ex: member
        const allSubModules = projectAllModules
          .filter((item) => item.name === navModule)
          .map((item) => item.subs)[0]
        // console.log("allSubModules", allSubModules)
        const filtered_allSubModules = allSubModules?.filter((item) => {
          return !excludedSubs.some((x) => {
            return x.name === item.name
          })
        })
        // console.log({ filtered_allSubModules }, filtered_allSubModules?.length)
        return filtered_allSubModules
      } else {
        const clientSpecificSubModules = itemClient.setup
          .filter((item) => item.module === navModule)
          .map((item) => item.subs)[0]
        const filtered_clientSpecificSubModules =
          clientSpecificSubModules?.filter(
            // (item) => !excludedSubs.includes(item.name)
            (item) => {
              return !excludedSubs.some((x) => {
                return x.name === item.name
              })
            }
          )
        // console.log(
        //   { filtered_clientSpecificSubModules },
        //   filtered_clientSpecificSubModules?.length
        // )
        return filtered_clientSpecificSubModules
      }
    })[0]

  if (projectModules)
    return navModules.filter((x) =>
      projectModules.some((y) => y.name === x.module.toLowerCase())
    )

  return []
}

export const accessControlStatus = (
  navModules: NavModulesTypes[],
  navModule: ModuleTypes,
  accessStatus: AccessStatusTypes
) => {
  if (!accessStatus) return []
  const moduleAccessStatus = projectAllModules
    .filter((item) => item.name === navModule?.toLowerCase())
    .map((item) => item.access.status)[0]

  if (moduleAccessStatus.length) {
    // const subs = moduleAccessStatus.map((item) => {
    //   if (item.subs.length) return item.subs
    // })
    const subs = moduleAccessStatus
      .map((item) => item)
      .filter((item) => item.status === accessStatus.toLowerCase())
      .map((item) => item.subs)
      .filter((item) => item.length)
      .map((item) => item[0])
    const isAllSubs = subs.filter((item) => item?.name === '*')

    if (subs.length) {
      if (isAllSubs.length) {
        const projectModules = projectAllModules
          .filter((item) => item.name === navModule)
          .map((item) => item.subs)[0]
        return navModules.filter((x) =>
          projectModules.some((y) => y && y.name === x.module.toLowerCase())
        )
      } else {
        const projectModules = subs.map((item) => item)
        return navModules.filter((x) =>
          projectModules.some((y) => y && y.name === x.module.toLowerCase())
        )
      }
    } else {
      // const y = moduleAccessStatus
      // .filter((item) => item.module === navModule)
      // .map((item) => item.subs)[0]
      // console.log('subs - no status acccess control available - all')
    }
  } else {
    // console.log('status - no status acccess control available - all')
    // const xxx = navModules.filter((x) =>
    //   projectModules.some((y) => y.name === x.module.toLowerCase())
    // )
  }
  // if no status then return default navModules
  return navModules
}

const accessControlUserType = <C extends ClientNames>({
  resolvedNavModules,
  projectClient,
  userType,
  navModule,
  isTempBypass = false,
}: {
  resolvedNavModules: NavModulesTypes[]
  projectClient: C
  userType?: ClientUserTypeNames<C>
  navModule?: ModuleTypes
  isTempBypass?: boolean
}): NavModulesTypes[] => {
  // temporarily bypass clients without user types setup yet
  if (isTempBypass) return resolvedNavModules

  const clientUserTypes = USER_TYPES.find(
    (item) => item.client === projectClient?.toLowerCase()
  )
  const userTypeConfig = clientUserTypes?.userTypes.find(
    (item) => item.name === userType
  )

  if (!userTypeConfig) return resolvedNavModules

  // super_user: module wildcard = pass-through
  const isAllModules = userTypeConfig.setup.some((item) => item.module === '*')
  if (isAllModules) return resolvedNavModules

  // module level filter
  if (!navModule) {
    return resolvedNavModules.filter((x) =>
      userTypeConfig.setup.some((y) => y.module === x.module.toLowerCase())
    )
  }

  // sub-module level filter
  const moduleSetup = userTypeConfig.setup.find(
    (item) => item.module === navModule
  )
  if (!moduleSetup) return []

  const isAllSubs = moduleSetup.subs.some((item) => item.name === '*')

  if (isAllSubs) {
    return resolvedNavModules.filter(
      (x) => !moduleSetup.exclude.some((y) => y.name === x.module.toLowerCase())
    )
  }

  return resolvedNavModules.filter((x) =>
    moduleSetup.subs.some((y) => y.name === x.module.toLowerCase())
  )
}

export const accessControlNavigationWithUserTypes = <C extends ClientNames>({
  projectClient,
  navModules,
  userType,
  isTempBypass = false,
}: {
  projectClient: C
  navModules: NavModulesTypes[]
  userType?: ClientUserTypeNames<C>
  isTempBypass: boolean
}) => {
  const resolvedNavModules = accessControlNavigation(projectClient, navModules)
  const cleanNavModules = accessControlUserType({
    resolvedNavModules,
    projectClient,
    userType,
    isTempBypass,
  })
  return cleanNavModules
}

export const accessControlSubNavigationWithUserTypes = <C extends ClientNames>({
  projectClient,
  navModules,
  navModule,
  userType,
  isTempBypass = false,
}: {
  projectClient: C
  navModules: NavModulesTypes[]
  navModule: ModuleTypes
  userType?: ClientUserTypeNames<C>
  isTempBypass: boolean
}) => {
  const resolvedNavModules = accessControlSubNavigation(
    projectClient,
    navModules,
    navModule
  )
  const cleanNavModules = accessControlUserType({
    resolvedNavModules,
    projectClient,
    userType,
    isTempBypass,
  })
  return cleanNavModules
}

type SubEntry = {
  name: string
  subs?: { name: string }[]
  exclude?: { name: string | null }[]
}

export function isAccessAllowed<
  C extends ClientNames,
  M extends ModuleNames,
>(args: {
  client: C
  userType?: ClientUserTypeNames<C>
  module: M
  sub?: undefined
  subSub?: undefined
}): boolean
export function isAccessAllowed<
  C extends ClientNames,
  M extends ModuleNames,
  S extends SubModuleNames<M>,
>(args: {
  client: C
  userType?: ClientUserTypeNames<C>
  module: M
  sub: S
  subSub?: SubSubModuleNames<M, S>
}): boolean
export function isAccessAllowed<C extends ClientNames, M extends ModuleNames>({
  client,
  userType,
  module,
  sub,
  subSub,
}: {
  client: C
  userType?: ClientUserTypeNames<C>
  module: M
  sub?: string
  subSub?: string
}): boolean {
  // 1. Client setup check
  const clientEntry = projectAllClients.find((c) => c.name === client)
  if (!clientEntry) return false

  const moduleSetup = clientEntry.setup.find((s) => s.module === module)
  if (!moduleSetup) return false

  if (sub) {
    const clientSubs = moduleSetup.subs as SubEntry[]
    const isAllSubs = clientSubs.some((s) => s.name === '*')
    if (isAllSubs) {
      if (moduleSetup.exclude.some((e) => e.name === sub)) return false
    } else {
      if (!clientSubs.some((s) => s.name === sub)) return false
    }

    if (subSub) {
      const subEntry =
        clientSubs.find((s) => s.name === sub) ??
        clientSubs.find((s) => s.name === '*')
      if (subEntry?.subs) {
        const isAllSubSubs = subEntry.subs.some((s) => s.name === '*')
        if (isAllSubSubs) {
          if ((subEntry.exclude ?? []).some((e) => e.name === subSub))
            return false
        } else {
          if (!subEntry.subs.some((s) => s.name === subSub)) return false
        }
      }
      // no sub-sub config on entry → downward * → pass
    }
  }

  // 2. User type check
  if (!userType) return true

  const clientUserTypes = USER_TYPES.find((ut) => ut.client === client)
  const userTypeConfig = clientUserTypes?.userTypes.find(
    (ut) => ut.name === userType
  )

  if (!userTypeConfig) return true

  // module: '*' means all modules — but subs/exclude still apply
  const wildcardSetup = userTypeConfig.setup.find((s) => s.module === '*')
  const moduleUserSetup =
    userTypeConfig.setup.find((s) => s.module === module) ?? wildcardSetup
  if (!moduleUserSetup) return false

  if (sub) {
    const isAllSubs = moduleUserSetup.subs.some((s) => s.name === '*')
    if (isAllSubs) {
      if (moduleUserSetup.exclude.some((e) => e.name === sub)) return false
    } else {
      if (!moduleUserSetup.subs.some((s) => s.name === sub)) return false
    }

    if (subSub) {
      const subUserEntry =
        moduleUserSetup.subs.find((s) => s.name === sub) ??
        moduleUserSetup.subs.find((s) => s.name === '*')
      if (subUserEntry?.subs) {
        const isAllSubSubs = subUserEntry.subs.some((s) => s.name === '*')
        if (isAllSubSubs)
          return !(subUserEntry.exclude ?? []).some((e) => e.name === subSub)
        return subUserEntry.subs.some((s) => s.name === subSub)
      }
      // no sub-sub config → downward * → pass
    }
  }

  return true
}

export function accessControlChecker<C extends ClientNames>(
  client: C,
  userType?: ClientUserTypeNames<C>
) {
  return function can<M extends ModuleNames, S extends SubModuleNames<M>>(
    module: M,
    sub?: S,
    subSub?: SubSubModuleNames<M, S>
  ): boolean {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (isAccessAllowed as any)({ client, userType, module, sub, subSub })
  }
}

const can = accessControlChecker(projectClient, 'super_user')

export const isVisibleUI = {
  member: {
    lookup: {
      create_member: can('member', 'transaction', 'download transaction'),
      create_drd_member: can('member', 'lookup', 'create drd member'),
    },
    transaction: {
      download_transaction: can(
        'member',
        'transaction',
        'download transaction'
      ),
    },
    communication: {
      view_email: can('member', 'communication', 'view email'),
      resend_email: can('member', 'communication', 'resend email'),
      edit_email: can('member', 'communication', 'edit email'),
    },
    communication_main_nz: {
      view_email: can('member', 'communication main nz', 'view email'),
      resend_email: can('member', 'communication main nz', 'resend email'),
      edit_email: can('member', 'communication main nz', 'edit email'),
    },
    voucher: {
      update_voucher_status: can('member', 'voucher', 'update voucher status'),
    },
    membership: {
      add_membership: can('member', 'membership', 'add membership'),
      end_membership: can('member', 'membership', 'end membership'),
    },
    identification: {
      merge_identifiers: can('member', 'identification', 'merge identifiers'),
      update_identifier_status: can(
        'member',
        'identification',
        'update identifier status'
      ),
    },
    identification_hampsta: {
      add_replace_card: can(
        'member',
        'identification hampsta',
        'add/replace card'
      ),
      update_identifier_status: can(
        'member',
        'identification hampsta',
        'update identifier status'
      ),
      identification_generic: {
        update_identifier_status: can(
          'member',
          'identification hampsta',
          'update identifier status'
        ),
      },
      banks_accounts: {
        add_bank_account: can('member', 'bank accounts', 'add bank account'),
        update_bank_account: can(
          'member',
          'bank accounts',
          'update bank account'
        ),
      },
      direct_payments: {
        add_payment_instruction: can(
          'member',
          'direct payments',
          'add payment instruction'
        ),
        update_payment_instruction: can(
          'member',
          'direct payments',
          'update payment instruction'
        ),
        skip_payment_instruction: can(
          'member',
          'direct payments',
          'skip payment instruction'
        ),
        cancel_payment_instruction: can(
          'member',
          'direct payments',
          'cancel payment instruction'
        ),
      },
      notes: {
        view_note: can(
          'member',
          'notes',
          'view note'
        ),
        update_note: can(
          'member',
          'notes',
          'update note'
        ),
      }
    },
  },
  merchant: {
    lookup: {
      create_merchant: can('merchant', 'lookup', 'create merchant'),
    },
    transaction: {
      download_transaction: can(
        'merchant',
        'transaction',
        'download transaction'
      ),
    },
    identification: {
      update_identifier_status: can(
        'merchant',
        'identification',
        'update identifier status'
      ),
    },
    device: {
      update_merchant_device: can(
        'merchant',
        'device',
        'update merchant device'
      ),
    },
    bank_accounts: {
      update_merchant_device: can(
        'merchant',
        'bank accounts',
        'update bank account'
      ),
    },
  },
  voucher: {
    view_voucher: {
      duplicate_voucher: can('voucher', 'view voucher', 'duplicate voucher'),
    },
  },
  reports: {
    report_2: {
      download_report: can('reports', 'report 2', 'download report'),
    },
    report_13: {
      download_report: can('reports', 'report 13', 'download report'),
    },
    report_19: {
      download_report: can('reports', 'report 19', 'download report'),
    },
    voucher_redemption_count_report: {
      download_report: can(
        'reports',
        'voucher redemption count report',
        'download report'
      ),
    },
  },
}

// const status = 'Registered'.toLowerCase() as AccessStatusTypes
// accessControlStatus('subsquad', [], 'closed')

export const isGenericClient = (projectClient: ClientNames): boolean =>
  projectClient === 'generic'

export const isRRClient = (projectClient: ClientNames): boolean =>
  projectClient === 'redrooster'

export const isOPClient = (projectClient: ClientNames): boolean =>
  projectClient === 'oporto'

export const isPPClient = (projectClient: ClientNames): boolean =>
  projectClient === 'paperplus'

export const isCRClient = (projectClient: ClientNames): boolean =>
  projectClient === 'columbuscoffee'

export const isCTClient = (projectClient: ClientNames): boolean =>
  projectClient === 'chickentreat'

export const isWFClient = (projectClient: ClientNames): boolean =>
  projectClient === 'westfield'

export const isWWClient = (projectClient: ClientNames): boolean =>
  projectClient === 'countdown'

export const isHampstaClient = (projectClient: ClientNames): boolean =>
  projectClient === 'hampsta'

export const isQSRHClient = (projectClient: ClientNames): boolean =>
  (['oporto', 'redrooster', 'chickentreat'] as const).includes(
    projectClient as 'oporto' | 'redrooster' | 'chickentreat'
  )

export const isMainNZClient = (projectClient: ClientNames): boolean =>
  !isQSRHClient(projectClient) && !isWFClient(projectClient)

export const displayBalanceCurrency = (
  projectClient: ClientNames,
  countryIsoCode: CurrencyTypes[]
): CurrencyTypes[] => {
  const projectModules = projectAllClients
    .filter((item) => item.name === projectClient?.toLowerCase())
    .map((item) => item.misc)[0]

  const filteredCountryIsoCode = countryIsoCode.filter((x) =>
    projectModules.some((y) => y.countryCode === x.countryCode)
  )
  return filteredCountryIsoCode
}
